export enum LoginError {
	None,
	General,
	DateError,
	Easy2User,
	GuestUser,
	LogedOutFromOtherTab,
	InternetIsDisconnected,
	ForceContract2
}

export interface AccesToken {
	nbf: number;
	exp: number;
	iss: string;
	aud: string[];
	client_id: string;
	sub: string;
	auth_time: number;
	idp: string;
	pk: string;
	two_factor_enabled: string;
	preferred_username: string;
	name: string;
	email: string;
	phone_number: string;
	phone_number_verified: boolean;
	display_name: string;
	firstname: string;
	lastname: string;
	national_id: string;
	national_id_verified: string;
	customer_isin: string;
	bourse_code: string;
	creator_client: string;
	contract: string[];
	scope: string[];
	amr: string[];
	isforce_contract?: string;
}
